<template>
    <v-app id="inspire"
    >
        <v-row
            justify="center"
        >
            <v-card
                class="col-sm-6"
            >
                <div class="col">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >

                        <v-text-field
                            v-model="qlist.name"
                            :rules="nameRules"
                            label="Name"
                            required
                            autocomplete="off"
                        ></v-text-field>

                        <v-text-field
                            v-model="qlist.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            autocomplete="off"
                        ></v-text-field>


                        <vue-tel-input
                            v-model="qlist.phone_no"
                            name="phone"
                            defaultCountry="SG"
                            :onlyCountries="['SG', 'MY', 'CN', 'HK']"
                            required
                            :maxLen="15"
                            enabledCountryCode
                            validCharactersOnly
                            :wrapperClasses="['mobile-input']"
                            @validate="validateMobile"
                            @open="openMobile"
                            class="col ma-2"
                            autocomplete="off"
                        ></vue-tel-input>
                        <v-row
                            v-if="phone_no.length > 0 && !mobileIsValid"
                            justify="center"
                            style="margin-top: -18px; margin-bottom: 5px;"
                        >
                            <v-flex class="col-6 ml-1">
                                <span style="font-size: 10px; color: red">Your mobile number is invalid</span>
                            </v-flex>
                        </v-row>

                        <v-text-field
                            v-model="password"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required]"
                            :type="showPassword ? 'text' : 'password'"
                            label="Password"
                            @click:append="showPassword = !showPassword"
                            autocomplete="off"
                        ></v-text-field>

                        <v-btn
                            :disabled="!valid"
                            color="primary"
                            class="mr-4 col"
                            @click="submit"
                            rounded
                        >
                            Sign up
                        </v-btn>
                    </v-form>
                </div>
            </v-card>
        </v-row>
    </v-app>
</template>

<script>
export default {
    props: ['group_id', 'outlet_id', 'qlist_id', 'qlist'],
    data: () => ({
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Name is required',
        ],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        password: '',
        showPassword: false,
        rules: {
            required: value => !!value || 'Required.',
        },
        phone_no: '',
        internationalPhone: '',
        mobileIsValid: false,
        countryCodes: [
            {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
            {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
            {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
            {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
        ],
        otpDialog: false,
        otpConfirm: '',
        otp: '',
    }),
    methods: {
        validate() {
            this.$refs.form.validate()
        },
        submit() {
            if (this.$refs.form.validate()) {
                let oid = this.outlet_id;
                axios.post('/register', {
                    name: this.qlist.name,
                    email: this.qlist.email,
                    phone_no: this.internationalPhone,
                    password: this.password,
                    group_id: this.group_id,
                    qlist_id: this.qlist_id,
                }).then(function (result) {
                    window.location.href = '/outlet/' + oid
                });
            }
        },
        validateMobile(phoneObject) {
            this.mobileIsValid = phoneObject.valid;
            this.country_code = phoneObject.country_code;
            if (phoneObject.valid && phoneObject.nationalNumber) {
                this.internationalPhone = phoneObject.country.dialCode + phoneObject.nationalNumber
            }
        },
        openMobile() {
            // Manually set using JS because CSS isn't applying the style
            const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style;
            if (dropdownElementStyle) {
                dropdownElementStyle.fontSize = "14px";
                dropdownElementStyle.width = "250px";
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Register.vue